export type DeleteProjectStakeholdersRequest = {
  pjtId: string;
  pjtTypeCd: string;
  stakeholderList: DeleteRequestStakeholder[];
  updateDateTime: string;
};

export type DeleteRequestStakeholder = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  teamCd: string;
  userId: string;
  index: number;
};
